import request from '@/utils/request'
import qs from 'qs'

export function getLostItemListApi(query) {
  return request({
    url: '/booking-service/v1/lost-item',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
  })
}
export function getLostItemListApiExcel(query) {
  return request({
    url: '/booking-service/v1/lost-item/excel',
    method: 'get',
    params: query,
    paramsSerializer: query =>
      qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      }),
    responseType: 'blob'
  })
}
